import React from 'react'
import Card from "@material-ui/core/Card";

const styles = {
    card: {
        borderRadius: '1.75em',
        marginBottom: '0.5em',
        fontSize: '14px',
        border: 'none',
        boxShadow: 'none',
        fontWeight: '500',
        padding: "1em 1.5em",
        display: 'flex',
        lineHeight: '1.4em',
        justifyContent: 'space-between',
    },
    accepted: {
        backgroundColor: '#a5bdff',
        color: '#ffffff',
    },
    waiting: {
        backgroundColor: '#ffffff',
        color: '#a5bdff',
        border: '2px solid #eeecec'
    },
    last: {
        backgroundColor: '#f6f5f5',
        color: '#a5bdff',
    },
    phone_image: {
        width: '3.2em'
    },
    one_type: {
        marginBottom: '2em'
    },
    controls: {
        display: 'flex',
        alignItems: 'center'
    },
    button: {
        backgroundColor: '#a5bdff',
        padding: '0.9em 1em',
        borderRadius: '0.75em',
    },
    booking_url: {
        textDecoration: 'none',
        color: '#ffffff'
    },
};


export const BookingHistoryElement = ({booking, type, cancelOrderClickCallback}) => (
    <Card style={{...styles.card, ...styles[type]}}>
        <div>
            <div>{booking.room.studio_name}</div>
            <div>{booking.room.name}</div>
            <div>{booking.datetime} </div>
            <div>{booking.price} </div>
        </div>
        <div style={styles.controls}>
            {booking.room.studio_phone && (type === 'waiting' || type === 'accepted') ?
                <a href={`tel:${booking.room.studio_phone}`}>
                    <img style={styles.phone_image} alt="phone-icon"
                         src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/phone.png'}/>
                </a> : ''}
            {type === 'last' ?
                <a href={booking.booking_url} style={styles.booking_url}>
                    <div style={styles.button}>
                        Повторить
                    </div>
                </a> : ''}
            {type === 'accepted' && booking.can_be_canceled
                ? <div className="cancel-booking-button" onClick={() => cancelOrderClickCallback(booking.id)}>
                    <img style={styles.phone_image} alt="cancel-icon"
                         src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/cancel_booking.png'}/>
                </div>
                : ''}
            {type === 'accepted' && booking.recurrent_type
                ? <img className="recurrent-icon" alt="recurrent-icon-icon"
                       src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/icons/recurrent-orange.svg'}/>
                : ''}
        </div>
    </Card>
);



